@if (showMainShell()) {
  @defer {
    <data-lens-layout />
  }
} @else {
  <router-outlet />
}
@if (loaderService.ongoingRequests()) {
  <data-lens-loader />
}
